import { render, staticRenderFns } from "./JdhValidationProvider.vue?vue&type=template&id=8b850f26&scoped=true&"
import script from "./JdhValidationProvider.vue?vue&type=script&lang=ts&"
export * from "./JdhValidationProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b850f26",
  null
  
)

export default component.exports